import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import classnames from 'clsx';

import { InlineMessageTypePropType } from './prop-types';
import style from './style.module.css';
import { INLINE_MESSAGE_TYPES } from './types';
import { Tooltip } from '../tooltip';

/**
 * @typedef {import('./inline-message-types.d.ts').InlineMessageComponent} InlineMessageComponent
 */

/**
 * @typedef {import('./inline-message-types.d.ts').WithTooltipComponent} WithTooltipComponent
 */

const Icon = {
  [INLINE_MESSAGE_TYPES.error]: <FontAwesomeIcon className={style.icon} icon={faExclamationCircle} />,
  [INLINE_MESSAGE_TYPES.warning]: <FontAwesomeIcon className={style.icon} icon={faExclamationTriangle} />,
  [INLINE_MESSAGE_TYPES.info]: <FontAwesomeIcon className={style.icon} icon={faInfoCircle} />,
};

/**
 * WithTooltip component
 * @type {WithTooltipComponent}
 */
const WithTooltip = ({ tooltipContent, children }) => (tooltipContent ? <Tooltip text={tooltipContent}>{children}</Tooltip> : children);

/**
 * @deprecated Use `Alert` from `@mantine/core` instead.
 * See: ui-components/readme-documentation/MIGRATION.md
 * @type {InlineMessageComponent}
 */
export const InlineMessage = ({ children, className = '', type = '', tooltipContent }) => (
  <WithTooltip tooltipContent={tooltipContent}>
    <div className={classnames(style['helper-text'], style[type], className)}>
      {INLINE_MESSAGE_TYPES[type] ? Icon[type] : null}
      <div className={style.text}>{children}</div>
    </div>
  </WithTooltip>
);

export { InlineMessageTypePropType, INLINE_MESSAGE_TYPES };
